import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy: React.FC = () => {
  return (
    <div>
      <div className="max-w-4xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-8">
          <Link to="/" className="mb-4 inline-block" style={{ color: 'var(--highlight)' }}>
            ← Back to Home
          </Link>
          <h1 className="text-3xl font-bold mb-4" style={{ color: 'var(--text-primary)' }}>
            Privacy Policy
          </h1>
{/*           <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>
            Last updated: {new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}
          </p> */}
        </div>


        <div className="mb-8 p-6 rounded-lg" style={{ backgroundColor: 'var(--surface)', border: '1px solid var(--border)' }}>
          <h2 className="text-lg font-semibold mb-3" style={{ color: 'var(--text-primary)' }}>
            Privacy in Plain English
          </h2>
          <p className="mb-4" style={{ color: 'var(--text-secondary)' }}>
            We care about your privacy — here’s the quick version:
          </p>
          <ul className="list-disc pl-6 space-y-2" style={{ color: 'var(--text-secondary)' }}>
            <li>We don’t use cookies or track you across the web.</li>
            <li>We collect minimal info — just anonymised stats about how the site is used, plus your email (and your name if you choose to give it) when you register.</li>
            <li>We use that info to run the site (this might include occasional prediction performance emails to you, but you can opt out of these at any time), improve it, and get in touch if needed — nothing more.</li>
            <li>We never sell your data, and we only share it if the law requires or with trusted partners who help us run the site.</li>
            <li>You can ask to see, update, or delete your info any time — just email us.</li>
          </ul>
          <p className="mt-4" style={{ color: 'var(--text-secondary)' }}>
            If you want the full legal details, keep reading below.
          </p>
        </div>

        {/* Content */}
        <div className="card rounded-lg shadow p-8 bg-gray-50 dark:bg-gray-800/50">
          <div className="prose prose-lg max-w-none" style={{ color: 'var(--text-primary)' }}>




            
            <h2 className="text-xl font-semibold mb-4">Information We Collect</h2>
            <p className="mb-6" style={{ color: 'var(--text-secondary)' }}>
              We collect only the information necessary to provide our service. This includes:
              <ul>
                <li>Basic anonymised analytics (e.g. page views, browser type) - no personal identifiers.</li>
                <li>Your email address when you register an account.</li>
                <li>Your name, if you choose to provide it in your profile.</li>
              </ul>
              We do not use cookies or similar tracking technologies.
            </p>

            <h2 className="text-xl font-semibold mb-4">How We Use Your Information</h2>
            <p className="mb-6" style={{ color: 'var(--text-secondary)' }}>
              We use the information we collect to:
              <ul>
                <li>Provide and improve our services.</li>
                <li>Communicate with you regarding your account.</li>
                <li>Monitor usage trends to improve site performance (analytics are anonymised).</li>
              </ul>
            </p>

            <h2 className="text-xl font-semibold mb-4">Information Sharing and Disclosure</h2>
            <p className="mb-6" style={{ color: 'var(--text-secondary)' }}>
              We do not sell, rent, or trade your personal information. We may share data only:
              <ul>
                <li>When required by law or legal process.</li>
                <li>With service providers who help us deliver our services (e.g. hosting), under strict confidentiality obligations.</li>
              </ul>
            </p>

            <h2 className="text-xl font-semibold mb-4">Data Security</h2>
            <p className="mb-6" style={{ color: 'var(--text-secondary)' }}>
              We take appropriate technical and organisational measures to protect your information from unauthorised access, alteration, disclosure, or destruction.
            </p>

            <h2 className="text-xl font-semibold mb-4">Your Rights</h2>
            <p className="mb-6" style={{ color: 'var(--text-secondary)' }}>
              Under UK data protection law, you have the right to:
              <ul>
                <li>Access the personal data we hold about you.</li>
                <li>Request correction or deletion of your personal data.</li>
                <li>Object to or restrict certain types of processing.</li>
                <li>Withdraw your consent (where applicable).</li>
              </ul>
              To exercise these rights, please contact us using the details below.
            </p>

            <h2 className="text-xl font-semibold mb-4">Contact Us</h2>
            <p className="mb-6" style={{ color: 'var(--text-secondary)' }}>
              If you have any questions about this Privacy Policy or how your data is handled, please email us at <strong>support@predictorpro.com</strong>
            </p>

            <div className="mt-8 p-4 rounded-lg" style={{ backgroundColor: 'var(--surface)', border: '1px solid var(--border)' }}>
              <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>
                <strong>Note:</strong> This Privacy Policy is effective from 10th August 2025. We may update it from time to time to reflect changes in our practices or for legal reasons.
              </p>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 